module.exports = __webpack_public_path__ + "img/balloon.e69e4c67.svg";